<div class="condominium-container">
  <h1>Condomínios</h1>
  <div class="condominium-list">
    @for (condominium of condominiums; track condominium) {
      <mat-card
        class="condominium-card"
        (click)="onCondominiumClick(condominium)">
        <mat-card-content>
          <div class="card-content">
            <mat-icon>home</mat-icon>
            <div class="text-content">
              <h2>{{ condominium.name }}</h2>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    }

    <div class="divider">
      <mat-divider></mat-divider>
    </div>

    <mat-card class="create-card" (click)="onCreateCondominiumClick()">
      <mat-card-content>
        <div class="card-content">
          <mat-icon>add_circle</mat-icon>
          <div class="text-content">
            <h2>Criar condomínio</h2>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>